import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-badge-estados-comprobante',
  templateUrl: './badge-estados-comprobante.component.html',
  styleUrls: ['./badge-estados-comprobante.component.css'],
})
export class BadgeEstadosComprobanteComponent {
  @Input() idEstado!: number;
  @Input() descripcionEstado?: string;
  @Input() soloIcono: boolean = false; // Para mostrar solo el ícono

  getEstadoIcon(idEstado: number): string {
    const iconMap: { [key: number]: string } = {
      1: 'check_circle',        // Emitido
      2: 'block',               // Anulado
      3: 'schedule',            // Pendiente
      4: 'hourglass_empty',     // Pendiente autorización
      5: 'cancel',              // Rechazado
      6: 'verified',            // Autorizado
      7: 'done_all'             // Finalizado
    };
    return iconMap[idEstado] || 'info';
  }

  getEstadoClass(idEstado: number): string {
    const classMap: { [key: number]: string } = {
      1: 'estado-emitido',
      2: 'estado-anulado',
      3: 'estado-pendiente',
      4: 'estado-pendiente-autorizacion',
      5: 'estado-rechazado',
      6: 'estado-autorizado',
      7: 'estado-finalizado'
    };
    return classMap[idEstado] || '';
  }

  getEstadoDescripcion(idEstado: number): string {
    const descripcionMap: { [key: number]: string } = {
      1: 'Emitido',
      2: 'Anulado',
      3: 'Pendiente',
      4: 'Pendiente autorización',
      5: 'Rechazado',
      6: 'Autorizado',
      7: 'Finalizado'
    };
    return this.descripcionEstado || descripcionMap[idEstado] || 'Desconocido';
  }
}
